module.exports = __webpack_public_path__ + "img/agenda.11c6b256.svg";